import { render, staticRenderFns } from "./Unknown.vue?vue&type=template&id=dbc3d27a&scoped=true&"
import script from "./Unknown.vue?vue&type=script&lang=js&"
export * from "./Unknown.vue?vue&type=script&lang=js&"
import style0 from "./Unknown.vue?vue&type=style&index=0&id=dbc3d27a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc3d27a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
